module.exports = __webpack_public_path__ + "static/media/hashed.179f7c02.png";